import { render, staticRenderFns } from "./CommodityPanel.vue?vue&type=template&id=7dbb5025&scoped=true&"
import script from "./CommodityPanel.vue?vue&type=script&lang=js&"
export * from "./CommodityPanel.vue?vue&type=script&lang=js&"
import style0 from "./CommodityPanel.vue?vue&type=style&index=0&id=7dbb5025&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbb5025",
  null
  
)

export default component.exports